export const apiUrl = '/api/orgunits/changes/';
export const PAYMENTS_MODULE = 'PAYMENTS';
export const ORG_UNIT_CREATION = 'org_unit_creation';
export const CHANGE_REQUEST_STATUS = {
    NEW: 'new',
    REJECTED: 'rejected',
    APPROVED: 'approved',
};
